interface RedirectToLoginOptions {
  readonly email?: string | undefined;
  readonly loginUrl?: string | undefined;
  readonly redirectPath?: string | undefined;
}

function resolveOrigin(): string {
  const origin = window.location.origin;
  if (!origin) {
    throw new Error('Unable to resolve the current window origin for login routing.');
  }

  return origin;
}

function storeLoginPrefill(email: string, redirectTo: string): void {
  try {
    if (email) {
      localStorage.setItem('pifster_login_prefill', email);
    }
  } catch {
    // ignore storage errors
  }

  try {
    localStorage.setItem('pifster_redirect_to', redirectTo);
  } catch {
    // ignore storage errors
  }
}

export function redirectToLogin(options: RedirectToLoginOptions): void {
  const origin = resolveOrigin();
  const email = String(options.email ?? '').trim();
  const redirectPath = options.redirectPath ?? '/current-charities-grid/';
  const redirectTo = new URL(redirectPath, origin).href;
  const destination = new URL(options.loginUrl ?? '/wp-login.php', origin);

  storeLoginPrefill(email, redirectTo);

  if (email) {
    destination.searchParams.set('log', email);
  }
  destination.searchParams.set('redirect_to', redirectTo);

  window.location.href = destination.toString();
}
